import { dropLastWhile } from 'ramda';
import getTenantConfiguration from './getTenantConfiguration';

const getStsUrl = () => getTenantConfiguration().then(c => dropLastWhile(chr => chr === '/', c.tokenServiceUrl));

export default getStsUrl;
